<template>
    <div>
        <ControlledSubstancesLog
            v-if="reportId == CREPORT.TYPE.CONTROLLED_SUBSTANCE_LOG"
            :data="data"
        />

        <InventorySummary
            v-if="reportId == CREPORT.TYPE.INVENTORY_SUMMARY"
            :data="data"
            :dialogs="dialogs"
        />

        <UniqueDispensingLog
            v-if="reportId == CREPORT.TYPE.UNIQUE_DISPENSING_LOG"
            :data="data"
            :dialogs="dialogs"
        />

        <InventoryAlerts
            v-if="reportId == CREPORT.TYPE.INVENTORY_ALERTS"
            :data="data"
            :dialogs="dialogs"
        />

        <ProfitMargins
            v-if="reportId == CREPORT.TYPE.PROFIT_MARGIN"
            :data="data"
        />

        <InventoryAdjustments
            v-if="reportId == CREPORT.TYPE.INVENTORY_ADJUSTMENTS"
            :data="data"
        />

        <InventoryValueCOGS
            v-if="reportId == CREPORT.TYPE.INVENTORY_VALUE_COGS"
            :data="data"
            :dialogs="dialogs"
        />

        <ItemsByPriceType
            v-if="reportId == CREPORT.TYPE.ITEMS_BY_PRICE_TYPE"
            :data="data"
        />

        <SalesByItem
            v-if="reportId == CREPORT.TYPE.SALES_BY_ITEM"
            :data="data"
        />
        <InventoryLog
            v-if="reportId == CREPORT.TYPE.INVENTORY_LOG"
            :data="data"
        />
    </div>
</template>
<script>
import CREPORT from "@/constants/report.js";
import ControlledSubstancesLog from "@/components/report-inventory/controlled-substances-log";
import InventorySummary from "@/components/report-inventory/summary";
import UniqueDispensingLog from "@/components/report-inventory/unique-dispensing-log.vue";
import InventoryAlerts from "@/components/report-billing/inventory-alerts";
import ProfitMargins from "@/module/report/module/inventory/profit-margins";
import InventoryAdjustments from "@/module/report/module/inventory/inventory-adjustments";
import InventoryValueCOGS from "@/module/report/module/inventory/inventory-value-cogs";
import ItemsByPriceType from "@/module/report/module/inventory/items-by-price-type";
import SalesByItem from "@/components/report-inventory/sales-by-item";
import InventoryLog from "@/components/report-inventory/inventory-log";

export default {
    components: {
        ControlledSubstancesLog,
        InventorySummary,
        UniqueDispensingLog,
        InventoryAlerts,
        ProfitMargins,
        InventoryAdjustments,
        InventoryValueCOGS,
        ItemsByPriceType,
        SalesByItem,
        InventoryLog
    },
    props: {
        data: {
            default() {},
            type: Object
        },
        dialogs: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        reportId() {
            return this.$route.params.id;
        }
    },
    data() {
        return { CREPORT: CREPORT };
    }
};
</script>
